import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FaAngleLeft } from "react-icons/fa";
import { getContactDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Viewcontactus = () => {
  let token = localStorage.getItem("accessToken");
  const id = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const contactView = useSelector((state) => state.contactView);
  const { contact } = contactView;

  useEffect(() => {
    if (contactView) {
      if (contactView?.loading !== undefined) {
        setLoading(contactView?.loading);
      }
    }
  }, [contactView]);

  useEffect(() => {
    if (contact) {
      setValue("name", contact?.data?.firstname);
      setValue("email", contact?.data?.email);
      setValue("phone", contact?.data?.phone);
      setValue("subject", contact?.data?.subject);
      setValue("message", contact?.data?.message);
    }
  }, [contact]);

  useEffect(() => {
    dispatch(getContactDetails(token, id));
  }, [dispatch]);

  const {
    register,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">View Contact Us</h1>
        </div>

        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div"></div>
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  disabled={true}
                  {...register("name")}
                  placeholder="Enter  Name"
                />
              </div>
              <div className="formInput">
                <label>Phone</label>
                <input
                  type="text"
                  name="phone"
                  disabled={true}
                  {...register("phone")}
                  placeholder="Enter Phone"
                />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  disabled={true}
                  {...register("email")}
                  placeholder="Enter Email"
                />
              </div>
              <div className="formInput">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  disabled={true}
                  {...register("subject")}
                  placeholder="Enter Subject"
                />
              </div>
              <div className="formInput">
                <label>Message</label>

                <textarea
                  type="text"
                  disabled={true}
                  {...register("message")}
                  className="description-textarea"
                  name="message"
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
              </div>
              <div className="formInput"></div>

              {/* <button type="submit" disabled={true}>
                Save
              </button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewcontactus;
